import { useEffect, useMemo, useState } from "react";
import { UnderlyingListDaysCount, UnderlyingListMotive } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";
import { IUnderlyingListModuleProps } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.types";
import { getAllItemsFromUnderlyingListModule } from "src/components-mui/modules/underlying-lists-module/utils/get-all-items-from-underlying-list-module";
import { usePopulateUnderlyingFollowStore } from "src/hooks/following/use-populate-underlying-follow-store";
import { useUserStore } from "src/stores/user-store";
import { setReturnUrl } from "src/utils/set-return-url";

type IUseUnderlyingListsModuleParams = Pick<IUnderlyingListModuleProps, "underlyingLists" | "isOverlayEnabled">;

export const useUnderlyingListsModule = ({ underlyingLists, isOverlayEnabled }: IUseUnderlyingListsModuleParams) => {
    const { isLoggedIn } = useUserStore();
    const [daysCount, setDaysCount] = useState<UnderlyingListDaysCount>(UnderlyingListDaysCount.Seven);
    const [selectedMotive, setSelectedMotive] = useState<UnderlyingListMotive>(UnderlyingListMotive.TakingProfits);
    useEffect(() => {
        setReturnUrl();
    }, []);

    const allUnderlyingListItems = useMemo(() => getAllItemsFromUnderlyingListModule({ underlyingLists }), [underlyingLists]);
    usePopulateUnderlyingFollowStore(allUnderlyingListItems);

    const lists =
        underlyingLists?.[daysCount === UnderlyingListDaysCount.Seven ? "underlyingListForSevenDays" : "underlyingListForThirtyDays"] ?? null;

    return {
        daysCount,
        setDaysCount,
        selectedMotive,
        setSelectedMotive,
        lists,
        shouldShowOverlay: isOverlayEnabled && !isLoggedIn,
    };
};
